/* eslint-disable no-unreachable */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { BaseEntity } from ".";
import { getCachedTypeEntity } from "./TypeEntityCache";
import { getCachedBlueprintEntity, getCachedBlueprintEntityByTypeId } from "./BlueprintEntityCache";

export class BlueprintExplosionEntity extends BaseEntity {
  components: any[];
  materials: any[];
  excessMaterials: any[];
  constructor(props: any) {
    super(0, props);
    this._dataTypeName = "Blueprint Explosion";
    this.components = [];
    this.materials = [];
    this.excessMaterials = [];
  }
  async toJson(): Promise<Excel.EntityCellValue> {
    const props: any = this.props;

    var entity = await super.toJson();

    let entityTextSeparator = "";
    let entityText = "";

    // Compute components and materials
    // Reset the data living outside the function
    this.components = [];
    this.materials = [];
    this.excessMaterials = [];
    await this.explodeMaterialsM(props.products);
    props.components = this.components;
    props.materials = this.materials;
    props.excessMaterials = this.excessMaterials;

    // Properties
    if (entity.properties) {
      // -- Id
      delete entity.properties.id;
      // -- Data Type
      delete entity.properties.data_type;
      // -- Products
      if (Object.prototype.hasOwnProperty.call(props, "products")) {
        let elements: Excel.CellValue[][] = [];
        for (let i = 0; i < props.products.length; i++) {
          const product = props.products[i];
          const typeEntity = await getCachedTypeEntity(product.type_id);
          if (typeEntity != null) {
            const quantity = product.quantity;
            elements.push([
              {
                type: Excel.CellValueType.entity,
                text: `${typeEntity.props["name"]} x ${quantity}`,
                properties: {
                  type: await typeEntity.toJson(),
                  quantity: {
                    type: Excel.CellValueType.formattedNumber,
                    basicValue: quantity,
                    numberFormat: "##0",
                  },
                },
              },
            ]);
          }
        }
        if (elements.length > 0) {
          // Sort products by type name
          elements = elements.sort((a: any, b: any) =>
            a[0].properties.type.properties.name.basicValue.localeCompare(
              b[0].properties.type.properties.name.basicValue
            )
          );
          entity.properties["products"] = {
            type: Excel.CellValueType.array,
            elements: elements,
          };
          entityText = entityText.concat(
            `${entityTextSeparator}${elements.length} ${elements.length === 1 ? "product" : "products"}`
          );
          entityTextSeparator = ", ";
        }
      }
      // -- Components
      if (Object.prototype.hasOwnProperty.call(props, "components")) {
        let elements: Excel.CellValue[][] = [];
        for (let i = 0; i < props.components.length; i++) {
          const component = props.components[i];
          const typeEntity = await getCachedTypeEntity(component.type_id);
          if (typeEntity != null) {
            const quantity = component.quantity;
            elements.push([
              {
                type: Excel.CellValueType.entity,
                text: `${typeEntity.props["name"]} x ${quantity}`,
                properties: {
                  type: await typeEntity.toJson(),
                  quantity: {
                    type: Excel.CellValueType.formattedNumber,
                    basicValue: quantity,
                    numberFormat: "##0",
                  },
                },
              },
            ]);
          }
        }
        if (elements.length > 0) {
          // Sort components by type name
          elements = elements.sort((a: any, b: any) =>
            a[0].properties.type.properties.name.basicValue.localeCompare(
              b[0].properties.type.properties.name.basicValue
            )
          );
          entity.properties["components"] = {
            type: Excel.CellValueType.array,
            elements: elements,
          };
          entityText = entityText.concat(
            `${entityTextSeparator}${elements.length} ${elements.length === 1 ? "component" : "components"}`
          );
          entityTextSeparator = ", ";
        }
      }
      // -- Materials
      if (Object.prototype.hasOwnProperty.call(props, "materials")) {
        let elements: Excel.CellValue[][] = [];
        for (let i = 0; i < props.materials.length; i++) {
          const material = props.materials[i];
          const typeEntity = await getCachedTypeEntity(material.type_id);
          if (typeEntity != null) {
            const quantity = material.quantity;
            elements.push([
              {
                type: Excel.CellValueType.entity,
                text: `${typeEntity.props["name"]} x ${quantity}`,
                properties: {
                  type: await typeEntity.toJson(),
                  quantity: {
                    type: Excel.CellValueType.formattedNumber,
                    basicValue: quantity,
                    numberFormat: "##0",
                  },
                },
              },
            ]);
          }
        }
        if (elements.length > 0) {
          // Sort materials by type name
          elements = elements.sort((a: any, b: any) =>
            a[0].properties.type.properties.name.basicValue.localeCompare(
              b[0].properties.type.properties.name.basicValue
            )
          );
          entity.properties["materials"] = {
            type: Excel.CellValueType.array,
            elements: elements,
          };
          entityText = entityText.concat(
            `${entityTextSeparator}${elements.length} ${elements.length === 1 ? "material" : "materials"}`
          );
          entityTextSeparator = ", ";
        }
      }
      // -- Excess Materials
      if (Object.prototype.hasOwnProperty.call(props, "excessMaterials")) {
        let elements: Excel.CellValue[][] = [];
        for (let i = 0; i < props.excessMaterials.length; i++) {
          const material = props.excessMaterials[i];
          const typeEntity = await getCachedTypeEntity(material.type_id);
          if (typeEntity != null) {
            const quantity = material.quantity;
            elements.push([
              {
                type: Excel.CellValueType.entity,
                text: `${typeEntity.props["name"]} x ${quantity}`,
                properties: {
                  type: await typeEntity.toJson(),
                  quantity: {
                    type: Excel.CellValueType.formattedNumber,
                    basicValue: quantity,
                    numberFormat: "##0",
                  },
                },
              },
            ]);
          }
        }
        if (elements.length > 0) {
          // Sort materials by type name
          elements = elements.sort((a: any, b: any) =>
            a[0].properties.type.properties.name.basicValue.localeCompare(
              b[0].properties.type.properties.name.basicValue
            )
          );
          entity.properties["excess_materials"] = {
            type: Excel.CellValueType.array,
            elements: elements,
          };
          entityText = entityText.concat(
            `${entityTextSeparator}${elements.length} ${elements.length === 1 ? "excess material" : "excess materials"}`
          );
          entityTextSeparator = ", ";
        }
      }
    }

    // - Text
    entity.text = entityText !== "" ? entityText : "Blueprint Explosion";

    return entity;
  }
  async explodeMaterialsM(products: any[]): Promise<void> {
    let nextLevelComponents: any = [];
    for (let i = 0; i < products.length; i++) {
      const product = products[i];
      // console.log(`Product ${product.type_id}x${product.quantity}`);
      if (product.blueprint_id) {
        const blueprintEntity = await getCachedBlueprintEntity(product.blueprint_id);
        if (blueprintEntity !== null) {
          if (blueprintEntity.props.activities) {
            // Check wether the component is a manufactured component or a reaction
            const productActivity = blueprintEntity.props.activities["manufacturing"] ? "manufacturing" : "reaction";
            if (
              blueprintEntity.props.activities[productActivity] &&
              blueprintEntity.props.activities[productActivity].materials
            ) {
              if (
                blueprintEntity.props.activities[productActivity].materials[0].typeID ==
                blueprintEntity.props.activities[productActivity].products[0].typeID
              ) {
                return;
              }
              for (let j = 0; j < blueprintEntity.props.activities[productActivity].materials.length; j++) {
                const material = blueprintEntity.props.activities[productActivity].materials[j];
                // Check if material is a component
                const materialBlueprintEntity = await getCachedBlueprintEntityByTypeId(material.typeID);
                if (materialBlueprintEntity !== null) {
                  // It is a component with a blueprint
                  // Check if there is excess components to use
                  const { updatedList, remainingQuantity } = this.availableExcessMaterial(
                    this.excessMaterials,
                    material.typeID,
                    material.quantity * product.runs
                  );
                  if (updatedList !== null) this.excessMaterials = updatedList;
                  if (remainingQuantity > 0) {
                    // Check wether the component is a manufactured component or a reaction
                    const materialActivity = materialBlueprintEntity.props.activities["manufacturing"]
                      ? "manufacturing"
                      : "reaction";
                    // Compute the quantities
                    let runs = Math.ceil(
                      remainingQuantity /
                        materialBlueprintEntity.props.activities[materialActivity].products[0].quantity
                    );
                    const quantity =
                      materialBlueprintEntity.props.activities[materialActivity].products[0].quantity * runs;
                    const excessQuantity = quantity - remainingQuantity;
                    if (excessQuantity > 0) {
                      this.addMaterial(this.excessMaterials, material.typeID, excessQuantity);
                    }
                    //console.log(`- Component ${material.typeID}x${runs} runs`);
                    const component = {
                      type_id: material.typeID,
                      blueprint_id: materialBlueprintEntity.props.blueprintTypeID,
                      runs: runs,
                      quantity: quantity,
                    };
                    nextLevelComponents.push(component);
                    this.addMaterial(this.components, component.type_id, component.quantity - excessQuantity);
                  }
                } else {
                  // It is a raw material
                  //console.log(`- Raw material ${material.typeID}x${product.runs * material.quantity}`);
                  this.addMaterial(this.materials, material.typeID, product.runs * material.quantity);
                }
              }
            }
          }
        }
      } else {
        // Add raw material
        // console.log(`- Raw material ${product.type_id}x${product.quantity}`);
        this.addMaterial(this.materials, product.type_id, product.quantity);
      }
    }
    // Explode the next level of components
    if (nextLevelComponents.length > 0) {
      // console.log(`-- Explode ${components.length} component(s)`);
      await this.explodeMaterialsM(nextLevelComponents);
    }
  }

  addMaterial(list: any[], type_id: number, quantity: number): any[] {
    // console.log(`-- Adding ${type_id}x${quantity}`);
    const index = list.findIndex((item) => item.type_id === type_id);
    if (index >= 0) {
      list[index] = {
        ...list[index],
        quantity: list[index].quantity + quantity,
      };
    } else {
      list.push({
        type_id: type_id,
        quantity: quantity,
      });
    }
    return list;
  }

  availableExcessMaterial(
    list: { type_id: number; quantity: number }[],
    type_id: number,
    quantity: number
  ): { updatedList: any; remainingQuantity: number } {
    const index = list.findIndex((item) => item.type_id === type_id);
    if (index >= 0) {
      const availableQuantity = Math.min(list[index].quantity, quantity);
      const quantityInList = list[index].quantity;
      let updatedList = [...list];
      updatedList[index] = {
        ...updatedList[index],
        quantity: updatedList[index].quantity - availableQuantity,
      };
      if (updatedList[index].quantity === 0) {
        updatedList.splice(index, 1);
      }

      if (quantityInList >= quantity) {
        return { updatedList, remainingQuantity: 0 };
      } else {
        return { updatedList, remainingQuantity: quantity - quantityInList };
      }
    } else {
      return { updatedList: null, remainingQuantity: quantity };
    }
  }
}
